// extracted by mini-css-extract-plugin
export default {"card":"top-job-card_card__mJsma","logo":"top-job-card_logo__a2ZcK","logoWrapper":"top-job-card_logoWrapper__Otl53","colBox":"top-job-card_colBox__iOXGO"};